import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";
import Vue from "vue";
import { Roles } from "@/models/user/roles";
import { ProductType } from "@/models/products/product";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/landing/NotFound.vue")
  },
  {
    path: "/resubmit",
    alias: ["/expired"],
    name: "Resubmit",
    component: () => import("../views/landing/FormExpired.vue")
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/landing/Error.vue")
  },
  {
    path: "/customers",
    name: "Customers",
    component: () => import("../views/customers/CustomerList.vue")
  },
  {
    path: "/customers/orders/:id",
    name: "CustomerOrders",
    component: () => import("../views/customers/CustomerOrders.vue")
  },
  {
    path: "/quickship",
    name: "Quickship",
    component: () => import("../views/items/QuickshipList.vue")
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import("../views/orders/Checkout.vue")
  },
  {
    path: "/checkout/review",
    name: "OrderReview",
    component: () => import("../views/orders/OrderReview.vue"),
    props: route => ({
      props: route.params
    })
  },
  {
    path: "/checkout/submitted",
    name: "Submitted",
    component: () => import("../views/orders/Submitted.vue")
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import("../views/orders/Cart.vue")
  },
  {
    path: "/cart/:id",
    name: "SavedCart",
    component: () => import("../views/orders/Cart.vue")
  },
  {
    path: "/profile/my-orders",
    name: "MyOrders",
    component: () => import("../views/orders/OrderList.vue")
  },
  {
    path: `/items/:product(${ProductType.Base}|${ProductType.Chair}|${ProductType.Umbrella})`,
    name: "ItemCustomization",
    component: () => import("@/views/items/ItemCustomization.vue")
  },
  {
    path: "/",
    alias: ["/collections/umbrella"],
    component: () => import("@/views/collections/CollectionMenu.vue"),
    props: route => ({
      props: route.params
    }),
    children: [
      {
        path: `/collections/:product(${ProductType.Accessory}|${ProductType.Base}|${ProductType.Chair}|${ProductType.Umbrella})`,
        component: () => import("@/views/collections/CollectionMenu.vue"),
        props: route => ({
          props: route.params
        })
      }
    ]
  },

  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: () => import("@/views/auth/AuthCallback.vue")
  },
  {
    path: "/login",
    beforeEnter(to, from, next) {
      const callback = `${process.env.VUE_APP_URL}/auth/callback`;
      const loginUrl = `${process.env.VUE_APP_API_LARAVEL_URL}/auth/login?redirect=${encodeURIComponent(callback)}&app=${process.env.VUE_APP_SSO_APP_SLUG}`;
      window.location.replace(loginUrl);
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

const publicPaths = ["/login", "/auth/callback", "/error", "/resubmit", "/expired"];

router.beforeEach((to, from, next) => {
  if (to.query.redirect) {
    const query = { ...to.query };
    delete query.redirect;
    next({ path: to.path, query, replace: true });
    return;
  }

  //@ts-ignore
  const token = store.state.global.authToken;
  if (publicPaths.includes(to.path)) {
    next();
  } else if (!token) {
    next("/login");
  } else {
    next();
  }
});

export default router;
